class MessageBox {
    constructor(element) {
        this.element = element;
        this.init();
    }

    init() {
        this.setupCloseButton();
    }

    setupCloseButton() {
        const closeButton = this.element.querySelector('.close');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                this.close();
            });
        }
    }

    close() {
        this.element.classList.add('fade-out');
        this.element.addEventListener('transitionend', () => {
            this.element.remove();
        }, { once: true });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const messageBoxes = document.querySelectorAll('.message-box');
    if (messageBoxes.length > 0) {
        messageBoxes.forEach(box => new MessageBox(box));
    }
});
